var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 52,
    viewBox: "0 0 246 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(-10270 3157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(9432 -3839)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 246,
    height: 52,
    transform: "translate(838 682)",
    fill: "#d8483d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 48,
    height: 52,
    transform: "translate(1036 682)",
    fill: "#be2e23"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Download_App",
    "data-name": "Download App",
    transform: "translate(865 714)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download App")), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1047.077 701.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M21,7.908H1.245a2.07,2.07,0,0,1-.555-.05A1.087,1.087,0,0,1-.072,6.634,1.1,1.1,0,0,1,.9,5.652c.142-.014.285-.014.427-.014H21.072c-.107-.114-.164-.185-.228-.249-1.153-1.146-2.3-2.3-3.452-3.444A1.132,1.132,0,0,1,17.008.869a1.071,1.071,0,0,1,.769-.875,1.084,1.084,0,0,1,1.153.27c.534.52,1.053,1.053,1.587,1.58L24.53,5.858a1.151,1.151,0,0,1,0,1.815c-1.843,1.85-3.693,3.686-5.53,5.544a1.151,1.151,0,0,1-1.971-.512,1.093,1.093,0,0,1,.356-1.1c1.153-1.146,2.3-2.3,3.452-3.444a.975.975,0,0,1,.256-.135A.719.719,0,0,1,21,7.908Z",
    transform: "translate(0)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn);
export default __webpack_public_path__ + "static/media/btn.f80ca385866fa03ac472d7479a54a78b.svg";
export { ForwardRef as ReactComponent };